import { Component, OnInit } from '@angular/core';
import { Agent} from '../../../_models/agent';
import * as fromAgent from '../../../agent/state/agent.reducer';
import * as agentActions from '../../../agent/state/agent.actions';
import { UserGroup} from '../../../_models/user_group';
import * as fromUserGroup from '../../../userGroup/state/userGroup.reducer';
import * as userGroupActions from '../../../userGroup/state/userGroup.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './agent-shell.component.html'
})

export class AgentShellComponent implements OnInit {

    // componentActive = true;
    // errorMessage$: Observable<string>;
    agents$: Observable<Agent[]>;
    currentAgent$: Observable<Agent>;
    filterFields$: Observable<any>;
    userGroupList$: Observable<UserGroup[]>;

  constructor(
    private store: Store<fromAgent.State>,
    private storeUserGroup: Store<fromUserGroup.State>
  ) {
    // Se cargan los grupos de usuarios.
    this.storeUserGroup.dispatch( new userGroupActions.LoadUserGroups({
      f_name: null,
      f_email: null,
      f_group: null,
      f_permissions: null,
      f_activated: true
    }));
  }

  ngOnInit() {

    // this.store.pipe(select(fromAgent.getAgentList),
    //   takeWhile(() => this.componentActive))
    //   .subscribe(
    //   agents => {
    //         console.log(' >>>> Suscribirse a store getAgentList: ');
    //         console.log(agents);

    //         this.agents = agents;
    //       }
    // );

    this.agents$ = this.store.pipe(select(fromAgent.getAgentList)) as Observable<Agent[]>;
    this.currentAgent$ = this.store.pipe(select(fromAgent.getCurrentAgent)) as Observable<Agent>;
    this.filterFields$ = this.store.pipe(select(fromAgent.getFilterFields)) as Observable<any>;
    // Se obtienen los grupos de usuarios existentes.
    this.userGroupList$ = this.storeUserGroup.pipe(select(fromUserGroup.getUserGroupList)) as Observable<UserGroup[]>;

  }

  searchAgents(searchParams): void {

    console.log('---> GetAgentList searchParam ');
    console.log(searchParams);

    this.store.dispatch( new agentActions.LoadAgents(searchParams));
    // Se guarda el valor de los filtros de búsqueda de las obras.
    this.store.dispatch( new agentActions.SetFilterFields(searchParams));

  } // End function searchAgents

  setCurrentAgent(agentIn: Agent | null): void {

    console.log('---> setCurrentAgent agentIn ');
    console.log(agentIn);

    // if (agentIn === null) {
    //   this.store.dispatch( new agentActions.InicializeAgent());
    // }
    this.store.dispatch( new agentActions.SetCurrentAgent(agentIn));

  } // End function setCurrentAgent

  deleteAgent(deleteAgent: Agent): void {

    console.log('---> deleteAgent: ');
    console.log(this.deleteAgent);

    this.store.dispatch( new agentActions.DeleteAgent(deleteAgent));

  } // End function deleteAgent

} // End class AgentShellComponent
